document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('wishlist-form').addEventListener('submit', async function(e) {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(this));
    data.submitted_at = new Date().toISOString();

    await fetch('https://flow-webhooks.k8s.eu.codecreationlabs.cloud/webhook/s12jo0u9', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-webhook-token': '4n6c0s6u0q011d346d6c3a37134f6r1h5q35264t1c2l3k6o303p3s605u2r3h7u'
      },
      body: JSON.stringify(data)
    });

    document.getElementById('wishlist-form').style.display = 'none';
    document.getElementById('wishlist-success').style.display = 'block';
  });
});
